<template>
  <div>
    <Breadcrumbs>
      <router-link to="/home/member-info">
        {{ $t("menu.main.membershipInformation") }}
      </router-link>
      >
      {{ $route.meta.title }}
    </Breadcrumbs>
    <div class="form-container px-5 pb-15">
      <div class="text-heading--c-prm text-center py-6">
        {{ $t("memberInfo.changeLoginEmail") }}
      </div>

      <v-form ref="form" lazy-validation class="bg-white rounded px-5 py-5">
        <label for="currentEmail">{{ $t("memberInfo.currentEmail") }}</label>
        <div id="currentEmail" class="text-medium mb-4">
          {{ currentEmail }}
        </div>

        <label for="newEmail">{{ $t("memberInfo.newEmail") }}</label>
        <v-text-field
          :rules="[$rules.required, $rules.email]"
          v-model="newEmail"
          :disabled="!!token"
          class="mt-2 rounded-lg"
          x-large
          solo
          outlined
          flat
          type="email"
        />

        <label for="newEmailConfirm">{{ $t("memberInfo.confirmNewEmail") }}</label>
        <v-text-field
          :rules="[$rules.required, emailMatchRule]"
          v-model="newEmailConfirm"
          :disabled="!!token"
          class="mt-2 rounded-lg"
          x-large
          solo
          outlined
          flat
          type="email"
        />

        <template v-if="token">
          <label for="newEmailCode">{{ $t("memberInfo.newEmailCode") }}</label>
          <v-text-field
            :rules="[$rules.required, codeRule]"
            v-model="code"
            class="mt-6 rounded-lg"
            x-large
            solo
            outlined
            flat
            hide-details="auto"
          />
          <div class="mt-1">
            {{ newEmail }}に送信された認証コードを入力してください。
          </div>
        </template>
      </v-form>

      <v-btn
        elevation="0"
        x-large
        rounded
        block
        class="mt-3"
        color="btn-grad--orange"
        @click="changeButtonClicked"
      >
        {{ $t("buttons.change") }}
      </v-btn>

    </div>
    <return-to-member-info-modal v-model="done" :message="`メールアドレスの変更が完了しました`" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import ReturnToMemberInfoModal from '@/components/Modal/ReturnToMemberInfoModal'

export default {
  components: {
    Breadcrumbs,
    ReturnToMemberInfoModal
  },
  data () {
    return {
      newEmail: null,
      newEmailConfirm: null,
      code: null,
      token: null,
      validUntil: null,
      done: false,
    }
  },
  computed: {
    currentEmail () {
      return this.$store.state.user.userInfo?.email
    },
    emailMatchRule () {
      return (v) => v === this.newEmail || 'メールアドレスが一致しません'
    },
    codeRule () {
      return (v) => /^\d{6}$/.test(v) || '認証コードは6桁の数字で入力してください'
    },
  },
  async mounted () {
    await this.$store.dispatch('loadUserInfo')
  },
  methods: {
    clear () {
      this.newEmail = null
      this.newEmailConfirm = null
      this.code = null
      this.token = null
      this.validUntil = null  
    },
    async changeButtonClicked  () {
      if (this.token) {
        await this.confirmChangeEmail()
      } else {
        await this.startChangeEmail()
      }
    },
    async startChangeEmail () {
      if (this.$refs.form.validate()) {
        await this.$doLoading(async () => {
          await this.$showGqlError(async () => {
            const result = await this.$store.dispatch('startChangeEmail', {
              newEmail: this.newEmail
            })
            this.token = result.token
            this.validUntil = result.validUntil
          })
        })
        this.$toast.success(`${this.newEmail}に認証コードを送信しました。`)
      }
    },
    async confirmChangeEmail () {
      if (this.$refs.form.validate()) {
        await this.$doLoading(async () => {
          await this.$showGqlError(async () => {
            await this.$store.dispatch('confirmChangeEmail', {
              token: this.token,
              code: this.code
            })
          }, {
            CONFIRM_CHANGE_EMAIL_EXPIRED_TOKEN: () => {
              this.$toast.error('トークンの有効期限が切れています。もう一度最初からお試しください。')
              this.token = null
            }
          })
          await this.$store.dispatch('loadUserInfo')
        })
        this.clear()
        this.done = true
      }
    }
  }
}
</script>
